import React from 'react';
import DXFViewerComponent from '../../components/DXFViewerComponent';


const DxfApp = () => {
  // const filePath = 'files/Limpio.dxf'; //local
  return (
    <div>
      {/* <DXFViewerComponent filePath={filePath}/> */}
      <DXFViewerComponent />
    </div>
  );
};
export default DxfApp;
